import gql from 'graphql-tag';
import TimelineFragments from './timeline.fragments';

export default class TimelineQueries {
  static loadLogs = gql`
    query listDealroomLogs(
      $dealroomId: String!
      $limit: Float
      $offset: Float
      $sortBy: LogSortBy
      $sortOrder: SortOrder
      $timeInterval: String
      $participantIds: [String!]
      $eventTypes: [DealroomEventType!]
    ) {
      listDealroomLogs(
        dealroomId: $dealroomId
        limit: $limit
        offset: $offset
        sortBy: $sortBy
        sortOrder: $sortOrder
        timeInterval: $timeInterval
        participantIds: $participantIds
        eventTypes: $eventTypes
      ) {
        logs {
          id
          createdAt
          data {
            ... on DealroomVisitedEventLogData {
              ...visitedEventLogData
            }
            ... on DealroomPublishedEventLogData {
              ...publishedEventLogData
            }
            ... on DealroomUnpublishedEventLogData {
              ...unpublishedEventLogData
            }
            ... on DealroomParticipantCreatedEventLogData {
              ...participantCreatedEventLogData
            }
            ... on DealroomSystemParticipantCreatedEventLogData {
              ...systemParticipantCreatedEventLogData
            }
            ... on DealroomParticipantDeletedEventLogData {
              ...participantDeletedEventLogData
            }

            ... on DealroomPostCreatedEventLogData {
              ...postCreatedEventLogData
            }

            ... on DealroomActionPlanUpdatedEventLogData {
              ...actionPlanUpdatedEventLogData
            }
            ... on DealroomMilestoneEventLogData {
              ...milestoneEventLogData
            }
            ... on DealroomTaskEventLogData {
              ...taskEventLogData
            }
            ... on DealroomTaskUpdatedEventLogData {
              ...taskUpdatedEventLogData
            }

            ... on DealroomFileUploadedEventLogData {
              ...fileUploadedEventLogData
            }
            ... on DealroomFileDownloadedEventLogData {
              ...fileDownloadedEventLogData
            }
            ... on DealroomFileDeletedEventLogData {
              ...fileDeletedEventLogData
            }

            ... on DealroomContextualCommentReplyCreatedEventLogData {
              ...contextualCommentReplyCreatedEventLogData
            }
            ... on DealroomContextualCommentUpdatedEventLogData {
              ...contextualCommentUpdatedEventLogData
            }

            ... on DealroomDeletedEventLogData {
              ...deletedEventLogData
            }

            ... on DealroomFeatureSettingsUpdatedEventLogData {
              ...featureSettingsUpdatedEventLogData
            }

            ... on DealroomAccessRuleUpdatedEventLogData {
              ...accessRuleUpdatedEventLogData
            }

            ... on DealroomConversationMessageEventLogData {
              ...conversationMessageEventLogData
            }

            ... on DealroomEntityAdminRoomOwnerUpdatedEventLogData {
              ...entityAdminRoomOwnerUpdatedEventLogData
            }
            ... on DealroomParticipantRoomOwnerUpdatedEventLogData {
              ...participantRoomOwnerUpdatedEventLogData
            }
            ... on DealroomEntityAdminParticipantCreatedEventLogData {
              ...entityAdminParticipantCreatedEventLogData
            }
            ... on DealroomEntityAdminPublishedEventLogData {
              ...entityAdminPublishedEventLogData
            }
            ... on DealroomEntityAdminUnpublishedEventLogData {
              ...entityAdminUnpublishedEventLogData
            }

            ... on DealroomMeetingCreatedEventLogData {
              ...meetingCreatedEventLogData
            }
            ... on DealroomMeetingUpdatedEventLogData {
              ...meetingUpdatedEventLogData
            }
          }
        }
        totalCount
      }
    }
    ${TimelineFragments.visitedEventLogData}
    ${TimelineFragments.publishedEventLogData}
    ${TimelineFragments.unpublishedEventLogData}
    ${TimelineFragments.participantCreatedEventLogData}
    ${TimelineFragments.systemParticipantCreatedEventLogData}
    ${TimelineFragments.participantDeletedEventLogData}
    ${TimelineFragments.postCreatedEventLogData}
    ${TimelineFragments.actionPlanUpdatedEventLogData}
    ${TimelineFragments.milestoneEventLogData}
    ${TimelineFragments.taskEventLogData}
    ${TimelineFragments.taskUpdatedEventLogData}
    ${TimelineFragments.fileUploadedEventLogData}
    ${TimelineFragments.fileDownloadedEventLogData}
    ${TimelineFragments.fileDeletedEventLogData}
    ${TimelineFragments.contextualCommentReplyCreatedEventLogData}
    ${TimelineFragments.contextualCommentUpdatedEventLogData}
    ${TimelineFragments.deletedEventLogData}
    ${TimelineFragments.featureSettingsUpdatedEventLogData}
    ${TimelineFragments.accessRuleUpdatedEventLogData}
    ${TimelineFragments.conversationMessageEventLogData}
    ${TimelineFragments.entityAdminRoomOwnerUpdatedEventLogData}
    ${TimelineFragments.participantRoomOwnerUpdatedEventLogData}
    ${TimelineFragments.entityAdminParticipantCreatedEventLogData}
    ${TimelineFragments.entityAdminPublishedEventLogData}
    ${TimelineFragments.entityAdminUnpublishedEventLogData}
    ${TimelineFragments.meetingCreatedEventLogData}
    ${TimelineFragments.meetingUpdatedEventLogData}
  `;
}
